import { RouteDefinition } from '@core/interfaces/route.interface';
import { adapterReducer }  from '@core/store/adapter/adapter.reducer';
import { RouterState }     from '@core/store/router/router.state';
import { EntityAdapter }   from '@ngrx/entity';
import { createReducer }   from '@ngrx/store';
import { LoggerService }   from '@shared/services/logger.service';


export function routerReducer(
	storeId: string,
	initialState: RouterState,
	routerAdapter: EntityAdapter<RouteDefinition>,
	logger: LoggerService
) {
	return createReducer(
		initialState,

		...adapterReducer<RouteDefinition, RouterState>( storeId, routerAdapter, logger )

		// ROUTER SPECIFIC REDUCER
	);
}
